import { Badge, type BadgeProps } from '@/components/base/badge'
import type { ConnectorFamilyPinRole } from '@/gql/graphql'

interface Props {
  role: ConnectorFamilyPinRole
}

const colors: { [role: string]: BadgeProps['color'] } = {
  earth: 'green',
  live: 'amber',
  neutral: 'blue',
  signal: 'purple',
  shield: 'zinc',
}

export const RoleBadge = ({ role }: Props) => {
  return <Badge color={ colors[role] }>{ role }</Badge>
}
